import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';

export const JuryPage = () => {
  const juryMembers = [
    {
      name: 'Sarah Mitchell',
      title: 'Creative Director',
      organization: 'Global Exhibitions Ltd',
      expertise: 'Award-winning immersive design',
      image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop'
    },
    {
      name: 'Dr. Marcus Chen',
      title: 'Professor of Design',
      organization: 'Royal College of Art',
      expertise: 'Sustainable design practices',
      image: 'https://images.unsplash.com/photo-1556157382-97eda2d62296?w=400&h=500&fit=crop'
    },
    {
      name: 'Maria Rodriguez',
      title: 'Chief Experience Officer',
      organization: 'Innovative Spaces Inc',
      expertise: 'Technology-driven exhibitions',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=500&fit=crop'
    },
    {
      name: 'James Chen',
      title: 'Head of Design',
      organization: 'European Trade Shows',
      expertise: 'Large-scale architecture',
      image: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=500&fit=crop'
    },
    {
      name: 'Lisa Anderson',
      title: 'Brand Strategist',
      organization: 'Momentum Agency',
      expertise: 'Brand-driven experiences',
      image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop'
    },
    {
      name: 'Michael Roberts',
      title: 'Senior Designer',
      organization: 'Studio Norte',
      expertise: 'Interactive installations',
      image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop'
    },
    {
      name: 'Emily Watson',
      title: 'Vice President',
      organization: 'Design Collective',
      expertise: 'Visitor experience design',
      image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop'
    },
    {
      name: 'David Kim',
      title: 'Innovative Director',
      organization: 'Innovate Designs',
      expertise: 'Cutting-edge technology',
      image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop'
    },
    {
      name: 'Sophie Laurent',
      title: 'Brand Designer',
      organization: 'Nordic Designs',
      expertise: 'Minimalist architecture',
      image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=500&fit=crop'
    },
    {
      name: 'Robert Johnson',
      title: 'Experience Lead',
      organization: 'Global Events',
      expertise: 'Experiential marketing',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop'
    },
    {
      name: 'Yuki Tanaka',
      title: 'Chief Architect',
      organization: 'Tokyo Design Week',
      expertise: 'Modern exhibition spaces',
      image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop'
    },
    {
      name: 'Isabella Rossi',
      title: 'Sustainability Expert',
      organization: 'Green Events Group',
      expertise: 'Circular economy design',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop'
    },
    {
      name: 'Thomas Wagner',
      title: 'Senior Architect',
      organization: 'Berlin Design Studio',
      expertise: 'Structural innovation',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop'
    },
    {
      name: 'Amanda Peters',
      title: 'Design Director',
      organization: 'West Coast Exhibits',
      expertise: 'Brand storytelling',
      image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=400&h=500&fit=crop'
    },
    {
      name: 'Carlos Martinez',
      title: 'Executive Producer',
      organization: 'Latin Events Network',
      expertise: 'International exhibitions',
      image: 'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?w=400&h=500&fit=crop'
    },
    {
      name: 'Jennifer White',
      title: 'Design Consultant',
      organization: 'Design Forward',
      expertise: 'Conceptual design',
      image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=400&h=500&fit=crop'
    },
    {
      name: 'Daniel Brooks',
      title: 'Art Director',
      organization: 'Creative Minds Inc',
      expertise: 'Visual storytelling',
      image: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop'
    },
    {
      name: 'Rachel Green',
      title: 'Experience Designer',
      organization: 'Interaction Studio',
      expertise: 'User-centric design',
      image: 'https://images.unsplash.com/photo-1557296387-5358ad7997bb?w=400&h=500&fit=crop'
    },
    {
      name: 'Alexander Lee',
      title: 'Creative Lead',
      organization: 'Future Exhibits',
      expertise: 'Immersive environments',
      image: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop'
    },
    {
      name: 'Victoria Chen',
      title: 'Branding Expert',
      organization: 'Brand Vision Co',
      expertise: 'Brand activations',
      image: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=400&h=500&fit=crop'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-16 sm:py-20 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-gray-900 mb-3">
            Our Jury Panel
          </h1>
          <p className="text-sm sm:text-base text-gray-600 max-w-3xl mx-auto">
            World-renowned professionals evaluating submissions based on creativity, innovation, functionality, and overall excellence in exhibition stand design.
          </p>
        </div>
      </section>

      {/* Jury Members Grid */}
      <section className="pb-16 bg-white">
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 sm:gap-6" data-testid="jury-members-grid">
            {juryMembers.map((member, index) => (
              <div
                key={index}
                className="flex flex-col items-center"
                data-testid={`jury-member-${index}`}
              >
                {/* Photo */}
                <div className="w-full aspect-[3/4] rounded-lg overflow-hidden bg-gray-200 mb-3">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                
                {/* Name */}
                <h3 className="text-sm font-bold text-gray-900 text-center mb-1">
                  {member.name}
                </h3>
                
                {/* Title */}
                <p className="text-xs font-semibold text-amber-600 text-center mb-0.5">
                  {member.title}
                </p>
                
                {/* Organization */}
                <p className="text-xs text-gray-600 text-center mb-2">
                  {member.organization}
                </p>
                
                {/* Expertise */}
                <p className="text-xs text-gray-500 text-center mb-3">
                  {member.expertise}
                </p>
                
                {/* Biography Button */}
                <Link to={`/jurybio?index=${index}`}>
                  <Button
                    variant="outline"
                    className="text-xs px-4 py-1.5 h-auto rounded-full border-gray-300 hover:bg-gray-50"
                    data-testid={`biography-${index}`}
                  >
                    Biography
                  </Button>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};
